




































































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Edit from "./edit.vue";

@Component({
  components: {
    Edit
  }
})
export default class extends Mixins(MyList) {
  @Prop() appId!: number;

  @Prop() selectContent?: (...args: any[]) => any;

  @Prop() authUserId!: string;

  @Prop() from!: string;

  @Prop() stadiumId!: number;

  dispatchType = "oplatformapps/fans";

  dispatchTypeDelete = "oplatformapps/deletefan";

  selectedRowKeys: any[] = [];

  columns: any[] = [
    { title: "编号", scopedSlots: { customRender: "id" } },
    { title: "appid", dataIndex: "appid" },
    { title: "类型", scopedSlots: { customRender: "mp_type" } },
    { title: "昵称", dataIndex: "nickname" },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    { title: "手机号", dataIndex: "mobile" },
    {
      title: "绑定信息",
      scopedSlots: { customRender: "curator_stadium_name" }
    },
    { title: "openid/unionid", scopedSlots: { customRender: "openid" } },

    // { title: "unionid", dataIndex: "unionid" },
    { title: "性别", scopedSlots: { customRender: "sex" } },
    { title: "国别省份城市", scopedSlots: { customRender: "country" } },
    { title: "是否关注", scopedSlots: { customRender: "is_subscribe" } },
    { title: "关注时间", dataIndex: "subscribed_time" },

    { title: "操作", width: 150, scopedSlots: { customRender: "action" } }
  ];

  handleChange(e: any, id: number) {
    // console.log(e.target.checked);
    if (e.target.checked == true) {
      // 选中

      this.showTsConfirm({
        title: "确认信息",
        content: "你确定要绑定吗？",
        onOk: async () => {
          if (this.selectContent) {
            this.selectContent({ id });
          }

          // this.selectedRowKeys = selectedRowKeys;
        },
        onCancel: () => {
          //
        }
      });
    } else {
      // 取消选择
      // this.showTsConfirm({
      //   title: "确认信息",
      //   content: "确定要解绑微信吗？",
      //   onOk: async () => {
      //     const res = await this.$store.dispatch("stadium/unbindAuthUser", {
      //       stadium_id: this.stadiumId,
      //     });
      //     if (res && res.Message && res.Message === "success") {
      //       this.$message.success(res.Message);
      //       this.handleCancel();
      //     } else {
      //       this.$message.error(res.Message);
      //     }
      //   },
      // });
    }
  }

  mounted() {
    this.loadAuthUserGroups();

    let sorter_order = "";
    if (this.authUserId && this.authUserId !== "0") {
      sorter_order = "ascend";
    }
    this.loadData(
      {
        app_id: this.appId,
        from: this.from,
        auth_user_id: this.authUserId,
        sorter_order
      },
      false
    );

    if (this.authUserId !== "") {
      this.selectedRowKeys = [this.authUserId];
      // console.log(this.selectedRowKeys);
    }
  }
}
